import mtavari from '../../../photos/geo-image/mtavari.jpg';
import pirveli from '../../../photos/geo-image/tvpirveli.png';
import formula from '../../../photos/geo-image/formula.jpg';
import palitra from '../../../photos/geo-image/palitra.png';
import netgazeti from '../../../photos/geo-image/netgazeti.png';
import radiotavisufleba from '../../../photos/geo-image/radiotavisupleba.png';
import qronikaplus from '../../../photos/geo-image/qronikaplus.png';

import publika from '../../../photos/geo-image/publika.png';
import mtisambebi from '../../../photos/geo-image/mtisambebi.jpg';
import kavkasia from '../../../photos/geo-image/kavkasia.png';
import interpress from '../../../photos/geo-image/interpress.jpg';
import onge from '../../../photos/geo-image/onge.png';
import batumelebi from '../../../photos/geo-image/batumelebi.jpg';
import ambebi from '../../../photos/geo-image/ambebi.jpg';
import euronews from '../../../photos/geo-image/euronews.png';

import sazogadoebrivi from '../../../photos/geo-image/sazogadoebrivi.png';
import adjara from '../../../photos/geo-image/adjara.jpg';
import rustavi2 from '../../../photos/geo-image/rustavi2.png';
import maestro from '../../../photos/geo-image/maestro.png';
import imedi from '../../../photos/geo-image/imedi.jpg';


export const geos = [
  {
    logo: mtavari,
    alt: "mtavari",
    title: "Mtavari Arkhi",
    links: {
      website: "https://mtavari.tv/",
      facebook: "https://www.facebook.com/Mtavarinow",
      youtube: "https://www.youtube.com/@mtavariarkhi/",
    }
  },
  {
    logo: pirveli,
    alt: "pirveli",
    title: "Tv Pirveli",
    links: {
      website: "https://tvpirveli.ge/ka/",
      facebook: "https://www.facebook.com/tvpirveli.ge",
      instagram: "https://www.instagram.com/tvpirveli_official/",
      youtube: "https://www.youtube.com/@tvpirveli1/",
    }
  },
  {
    logo: formula,
    alt: "formula",
    title: "Formula",
    links: {
      website: "https://formulanews.ge/",
      facebook: "https://www.facebook.com/formulanews.ge",
      instagram: "https://www.instagram.com/FormulaOriginals/",
      youtube: "https://www.youtube.com/@FormulaNews/",
    }
  },
  {
    logo: palitra,
    alt: "palitra",
    title: "Palitra News",
    links: {
      website: "https://palitranews.ge/",
      facebook: "https://www.facebook.com/tvpalitranews",
      instagram: "https://www.instagram.com/palitranews/",
      youtube: "https://www.youtube.com/@PalitraNews/",
    }
  },
  {
    logo: netgazeti,
    alt: "netgazeti",
    title: "Netgazeti",
    links: {
      website: "https://netgazeti.ge/",
      facebook: "https://www.facebook.com/netgazeti/",
      instagram: "https://www.instagram.com/netgazeti/",
      youtube: "https://www.youtube.com/@netgazeti_news/",
    }
  },
  {
    logo: radiotavisufleba,
    alt: "radiotavisufleba",
    title: "Radio Tavisufleba",
    links: {
      website: "https://www.radiotavisupleba.ge/",
      facebook: "https://www.facebook.com/radiotavisupleba/",
      instagram: "https://www.instagram.com/tavisupleba/",
      youtube: "https://www.youtube.com/@Radio-Tavisupleba/",
    }
  },
  {
    logo: qronikaplus,
    alt: "qronikaplus",
    title: "Qronika+",
    links: {
      website: "https://qronikaplus.ge/",
      facebook: "https://www.facebook.com/qronikaplusge",
    }
  },
  {
    logo: publika,
    alt: "publika",
    title: "Publika",
    links: {
      website: "https://publika.ge/",
      facebook: "https://www.facebook.com/publika.ge/",
      instagram: "https://www.instagram.com/publika.ge/",
      youtube: "https://www.youtube.com/@publika8437/",
    }
  },
  {
    logo: mtisambebi,
    alt: "mtisambebi",
    title: "Mtis Ambebi",
    links: {
      website: "https://mtisambebi.ge/",
      facebook: "https://www.facebook.com/mtisambebi/",
      instagram: "https://www.instagram.com/mtisambebi.ge/",
      youtube: "https://www.youtube.com/@TVickge/",
    }
  },
  {
    logo: kavkasia,
    alt: "kavkasia",
    title: "Kavkasia",
    links: {
      website: "https://kavkasiatv.ge/",
      facebook: "https://www.facebook.com/kavkasiatv/",
      youtube: "https://www.youtube.com/@Tv.kavkasia/",
    }
  },
  {
    logo: interpress,
    alt: "interpress",
    title: "Interpressnews",
    links: {
      website: "https://www.interpressnews.ge/en/",
      facebook: "https://www.facebook.com/interpressnews.ge",
      instagram: "https://www.instagram.com/interpressnews/",
    }
  },
  {
    logo: onge,
    alt: "onge",
    title: "On.Ge",
    links: {
      website: "https://on.ge/",
      facebook: "https://www.facebook.com/news.on.ge/",
      instagram: "https://www.instagram.com/on.ge",
    }
  },
  {
    logo: batumelebi,
    alt: "batumelebi",
    title: "Batumelebi",
    links: {
      website: "https://batumelebi.netgazeti.ge/",
      facebook: "https://www.facebook.com/batumelebi/",
      instagram: "https://www.instagram.com/batumelebi.ge/",
      youtube: "https://www.youtube.com/@BatumelebiNews/",
    }
  },
  {
    logo: ambebi,
    alt: "ambebi",
    title: "Ambebi.Ge",
    links: {
      website: "https://www.ambebi.ge/",
      facebook: "https://www.facebook.com/ambebi.ge/",
      instagram: "https://www.instagram.com/ambebige/",
      youtube: "https://www.youtube.com/@rightsgeorgia1555/",
    }
  },
  {
    logo: euronews,
    alt: "euronews",
    title: "Euronews Georgia",
    links: {
      website: "https://euronewsgeorgia.com/",
      facebook: "https://www.facebook.com/euronewsgeorgia/",
      instagram: "https://www.instagram.com/euronewsgeorgia/",
      youtube: "https://www.youtube.com/@euronewsgeorgia/",
    }
  },
  {
    logo: sazogadoebrivi,
    alt: "sazogadoebrivi",
    title: "Public Broadcaster",
    links: {
      website: "https://1tv.ge/",
      facebook: "https://www.facebook.com/1stchannel.1tv.ge/",
      instagram: "https://www.instagram.com/1tv.ge/",
      youtube: "https://www.youtube.com/@GeorgianBroadcaster/",
    }
  },
  {
    logo: adjara,
    alt: "adjara",
    title: "Adjara Broadcaster",
    links: {
      website: "https://ajaratv.ge/",
      facebook: "https://www.facebook.com/AjaraTV",
      youtube: "https://www.youtube.com/@AjaraTVBroadcaster/",
    }
  },
  {
    logo: rustavi2,
    alt: "rustavi2",
    title: "Rustavi 2",
    links: {
      website: "https://rustavi2.ge/",
      facebook: "https://www.facebook.com/rustavi2/",
      instagram: "https://www.instagram.com/rustavi2official/",
      youtube: "https://www.youtube.com/@rustavi2official/",
    }
  },
  {
    logo: maestro,
    alt: "maestro",
    title: "Maestro",
    links: {
      website: "https://www.maestro.ge/",
      facebook: "https://www.facebook.com/profile.php?id=61562030100707",
      youtube: "https://www.youtube.com/@TVMaestro/",
    }
  },
  {
    logo: imedi,
    alt: "imedi",
    title: "Imedi",
    links: {
      website: "https://www.imedi.ge/",
      facebook: "https://www.facebook.com/tvimedi/",
      instagram: "https://www.instagram.com/tv.imedi/",
      youtube: "https://www.youtube.com/@TVIMEDI/",
    }
  },
  
];